import { ReactComponent as SvgFinger } from '@img/icons/finger.svg';
import { ReactComponent as SvgChevron } from '@img/icons/nav-arrow-right.svg';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import S from './SwipeIndicator.styles';
const SwipeIndicator = (props) => {
    return (React.createElement(AnimatePresence, { exitBeforeEnter: true }, props.isVisible ? (React.createElement(S.Container, { key: `${props.initialId}-gallery-swipe-indicator`, initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } }, Array.from({ length: 6 }).map((_, i) => (React.createElement(React.Fragment, { key: `gallery-swipe-indicator-${i}` },
        React.createElement(SvgChevron, null),
        i === 2 && React.createElement(SvgFinger, null)))))) : null));
};
export default SwipeIndicator;
